import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiPatchDispatchableWithoutSource } from '../../../../../../../core/dapi';
import { getInsuranceProfileByIdUrl } from '../../../../../../../core/dapi/insuranceProfile';
import { updateInsuranceProfile } from '../../../../../../../actions/insuranceProfile';
import { noOp } from '../../../../../../../actions';
import { safeGet } from '../../../../../../../core/util/object';
import useSelectInsuranceProfile from '../../../../../hooks/useSelectInsuranceProfile';

export default (userProfileId: any) => {
  const dispatch = useDispatch();
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);
  const insuranceProfileId = safeGet(insuranceProfile)('insurance_profile_id');

  return useCallback(() => {
    dispatch(
      apiPatchDispatchableWithoutSource(
        getInsuranceProfileByIdUrl(insuranceProfileId),
        { is_eligibility_rejection_error_dismissed: true },
        updateInsuranceProfile,
        noOp
      )
    );
  }, [dispatch, insuranceProfileId]);
};
